import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../AbstractElements";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { VerticalSliderTitle } from "../../../Constants/Constants";
import { VerticalSliderSubTitle } from "../../../Data/BonusUi/Carousel";

const VerticalSlider = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={VerticalSliderTitle} span={VerticalSliderSubTitle} />
        <CardBody>
          <Swiper direction={"vertical"} pagination={{ clickable: true }} modules={[Pagination]} className="mySwiper swiper-h">
            {dynamicNumber(7).map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(`slider/${item}.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VerticalSlider;
